import { bindActionCreators } from 'redux'
import { getProjects } from 'reduxpath/ducks/Project/List'
import { getProjectWithTaskStatus } from 'reduxpath/ducks/ProjectList/List'
import { getTasks } from 'reduxpath/ducks/TaskList/List'
import { getCountries, setSelectionsCountry } from 'reduxpath/ducks/Reference'
import {
  getProjectById,
  getQuotationByOrderId,
  getPoByOrderId,
  getOrderToolByOrderId,
  getOrderProfile,
  getCountryTax,
  getOrderDetailByOrderId,
  getInvitedCreatorByOrderId,
  getPurchaseOrderCreator,
  getPrevId,
  getNextId,
  getOrderReference,
  getPitchSummary,
  clearTabActive,
  getInvoiceWithCreator,
  getReviewByOrder,
  getPaymentLog,
} from 'reduxpath/ducks/Project/Detail'
import {
  getFeedback,
  getPitch,
  getPitchById,
  getPitchReference,
} from 'reduxpath/ducks/Project/Pitch'
import { getOrderReview } from 'reduxpath/ducks/Project/Management'
import { getRemittance } from 'reduxpath/ducks/Project/Remittance'
import { getComments } from 'reduxpath/ducks/Project/Comment'

import {
  getProfileById,
  getFinanceProfileByProfileId,
} from 'reduxpath/ducks/Profile/Detail'

import Home from 'units/Project'
import List from 'units/Project/units/List'
import Detail from 'units/Project/units/Detail'
import Pitch from 'units/Project/units/Pitch'
import Summary from 'units/Project/units/Summary'

import { getInvoices } from 'reduxpath/ducks/Project/PaymentConfirmation'

import { getTaxInvoices } from 'reduxpath/ducks/Tax/List'

const list = store => {
  const {
    searchProjectBrand,
    projectStatus,
    projectCountry,
    sortBy,
    data,
    isOrganicOnly,
  } = store.getState().ProjectList

  const qs = {
    sort: `${sortBy} DESC`,
    skip: data.currentPage ? (data.currentPage - 1) * 10 : 0,
    limit: 10,
    where: {
      or: [
        { name: { like: `%${searchProjectBrand}%` } },
        { brand: { like: `%${searchProjectBrand}%` } },
      ],
    },
  }

  if (isOrganicOnly) {
    qs.where.isOrganic = true
  }
  if (searchProjectBrand === qs.where.name) {
    qs.where.name = searchProjectBrand
  } else if (searchProjectBrand === qs.where.brand) {
    qs.where.brand = searchProjectBrand
  }

  if (projectStatus) {
    qs.where.status = projectStatus
  }
  if (projectCountry) {
    qs.where.country = projectCountry
  }

  store.dispatch(
    getCountries(countries => {
      store.dispatch(setSelectionsCountry(countries.rows))
    })
  )
  store.dispatch(getProjects(qs))
}

const detail = (store, id) => {
  const {
    searchProjectBrand,
    projectStatus,
    projectCountry,
    sortBy,
    isOrganicOnly,
  } = store.getState().ProjectList

  const actions = bindActionCreators(
    {
      getComments,
      getProjectById,
      getProfileById,
      getFinanceProfileByProfileId,
      getTaxInvoices,
      getCountryTax,
      getQuotationByOrderId,
      getPoByOrderId,
      getOrderToolByOrderId,
      getInvoices,
      getOrderProfile,
      getPitch,
      getRemittance,
      getOrderDetailByOrderId,
      getInvitedCreatorByOrderId,
      getPrevId,
      getNextId,
      getOrderReference,
      getProjectWithTaskStatus,
      getTasks,
      getPitchSummary,
      clearTabActive,
      getInvoiceWithCreator,
      getReviewByOrder,
      getOrderReview,
      getPaymentLog,
    },
    store.dispatch
  )
  actions.getProjectWithTaskStatus({
    sort: 'createdAt DESC',
    limit: 10,
    skip: 0,
    where: {
      id,
    },
  })
  actions.getTasks({
    sort: 'createdAt DESC',
    skip: 0,
    where: {
      order: id,
    },
  })
  actions.getTaxInvoices({ search: JSON.stringify({ order: id }) })
  actions.getProjectById(id, order => {
    actions.getProfileById(order.profile.profileId, profile => {
      actions.getFinanceProfileByProfileId(profile.id)
    })
    actions.getCountryTax(order.country.id)

    const qsnext = {
      sort: `${sortBy} DESC`,
      where: {
        [sortBy]: {
          '<': order[sortBy],
        },
        or: [
          { name: { like: `%${searchProjectBrand}%` } },
          { brand: { like: `%${searchProjectBrand}%` } },
        ],
      },
    }
    if (isOrganicOnly) {
      qsnext.where.isOrganic = true
    }
    if (projectStatus) {
      qsnext.where.status = projectStatus
    }
    if (projectCountry) {
      qsnext.where.country = projectCountry
    }
    actions.getNextId(qsnext)

    const qsprev = {
      sort: `${sortBy} ASC`,
      where: {
        [sortBy]: {
          '>': order[sortBy],
        },
        or: [
          { name: { like: `%${searchProjectBrand}%` } },
          { brand: { like: `%${searchProjectBrand}%` } },
        ],
      },
    }
    if (isOrganicOnly) {
      qsprev.where.isOrganic = true
    }
    if (projectStatus) {
      qsprev.where.status = projectStatus
    }
    if (projectCountry) {
      qsprev.where.country = projectCountry
    }
    actions.getPrevId(qsprev)
  })
  actions.getComments({
    limit: 5,
    sort: 'createdAt DESC',
    search: JSON.stringify({
      order: id,
    }),
  })
  actions.getQuotationByOrderId(id)
  actions.getPoByOrderId(id)
  actions.getOrderToolByOrderId(id)
  actions.getOrderProfile(id)
  actions.getOrderReference(id)
  actions.getPitch({ order: id })
  actions.getRemittance({ search: JSON.stringify({ order: id }) })
  actions.getInvoices(
    {
      order: id,
    },
    {
      sort: 'createdAt ASC',
      limit: 100000,
      skip: 0,
    }
  )
  actions.getOrderDetailByOrderId(id)
  actions.getInvitedCreatorByOrderId(id)
  actions.getPitchSummary({
    where: {
      order: id,
    },
  })
  actions.clearTabActive()
  actions.getInvoiceWithCreator({
    where: {
      order: id,
    },
  })
  actions.getOrderReview(
    {
      order: id,
    },
    () => {},
    ['profile', 'reviewedBy']
  )
  actions.getPaymentLog({
    where: {
      order: id,
    },
  })
}

const summary = (store, id) => {
  const actions = bindActionCreators(
    {
      getProjectById,
      getProfileById,
      getFinanceProfileByProfileId,
      getTaxInvoices,
      getCountryTax,
      getQuotationByOrderId,
      getPoByOrderId,
      getInvoices,
      getOrderProfile,
      getPitch,
      getOrderDetailByOrderId,
      getPurchaseOrderCreator,
    },
    store.dispatch
  )
  actions.getProjectById(id, order => {
    actions.getProfileById(order.profile.profileId, profile => {
      actions.getFinanceProfileByProfileId(profile.id)
      actions.getTaxInvoices({
        search: JSON.stringify({ order: id, profile: profile.id, type: 'client' }),
      })
    })
    actions.getCountryTax(order.country.id)
  })
  actions.getPurchaseOrderCreator(id)
  actions.getQuotationByOrderId(id)
  actions.getPoByOrderId(id)
  actions.getPitch({ order: id })
  actions.getInvoices(
    {
      order: id,
    },
    {
      sort: 'createdAt ASC',
      limit: 100000,
      skip: 0,
    }
  )
  actions.getOrderDetailByOrderId(id)
}

const pitch = (store, id) => {
  const actions = bindActionCreators(
    {
      getPitchById,
      getFeedback,
      getPitchReference,
    },
    store.dispatch
  )
  actions.getPitchById(id)
  actions.getFeedback(id)
  actions.getPitchReference(id)
}

export default {
  populate: {
    list,
    detail,
    pitch,
    summary,
  },
  components: {
    Home,
    List,
    Detail,
    Pitch,
    Summary,
  },
}
